import { Tooltip as AntTooltip, type TooltipProps } from 'antd'

export type UiTooltipProps = TooltipProps

export const UiTooltip = (props: UiTooltipProps) => <AntTooltip {...props} />

export default UiTooltip
